angular
    .module('MyApp')
    .service('DocumentosAlunoService', ['$resource', '$q', 'SessionData', 'Configs', function($resource, $q, SessionData, Configs) {

      this.listarDocumentos = function(codAluno){
        let deferr = $q.defer();
            $resource(Configs.getApiServer() + '/comum/documentos-visiveis-aluno?codAluno=' + codAluno,
                {}, { 'query': { method: 'GET', isArray: true } }).query({
                }, function (response) {
                  deferr.resolve(response);

                }, function(){
                    deferr.reject();
                });
        return deferr.promise;
      }

    }]);
